import React from 'react';
import type { NavItemType, IconsProps, INavViewItem } from '@makemydeal/dr-sales-checkin-types';

import { SEND_TO_DESK_SUBMITTING_LABEL } from '../../constants';
import { useSendToDesk } from '../../hooks/useSendToDesk';
import { StyledSendToDeskButton } from './sendToDeskButton.style';

const SendToDeskButton: React.FC<{ item: Extract<INavViewItem, { type: NavItemType.SendToDesk }> }> = ({ item }) => {
    const { isLoading, isSendToDeskClicked, onSendToDeskClick } = useSendToDesk();
    const Icon = item.icon as React.ComponentType<IconsProps> | undefined;

    return (
        <StyledSendToDeskButton
            buttonStyle="tertiary"
            buttonSize="small"
            data-testid="send-to-desk"
            disabled={isLoading || item.isDisabled}
            onClick={onSendToDeskClick}
        >
            {Icon && <Icon />}
            {isSendToDeskClicked ? SEND_TO_DESK_SUBMITTING_LABEL : item.label}
        </StyledSendToDeskButton>
    );
};

export default SendToDeskButton;
